import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import init, { InitOutput, process_image } from 'src/qr-wasm/qr_wasm';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-web-cam-scanner',
    templateUrl: './web-cam-scanner.component.html',
    styleUrls: ['./web-cam-scanner.component.scss'],
    standalone: true,
    imports: [FlexModule, NgIf]
})
export class WebCamScannerComponent implements OnInit, OnDestroy {
  instance: InitOutput;

  cameraOn: boolean = false;
  showCanvas: boolean = false;
  private barcodeFound: boolean = false;

  private animationId: number;
  private lastRenderingResult: string = 'Not scanned';

  @ViewChild("videoElement", { static: false })
  readonly video: ElementRef<HTMLVideoElement>;

  @ViewChild("canvas", { static: false })
  readonly canvas: ElementRef<HTMLCanvasElement>;

  @Input()
  readonly width: number = 300;

  @Input()
  readonly height: number = 250;

  private imageContext: CanvasRenderingContext2D;

  constructor() { }

  async ngOnInit() {
    this.instance = await init('../../../../qr-wasm/qr_wasm_bg.wasm');
    this.startTheCamera();
    this.barcodeFound = false;
  }

  ngOnDestroy(): void {
    this.stopThecamera();
    cancelAnimationFrame(this.animationId);    
  }

  startTheCamera() {
    this.showCanvas = true;
    if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: { height: this.height, width: this.width } })
        .then((s: MediaStream) => {
          if (this.video != undefined) {            
            const _video = this.video.nativeElement;
            _video.srcObject = s;   
            this.cameraOn = true;
            this.barcodeFound = false;
            this.imageContext = this.initializeCanvas();
            this.renderCanvas();
          }
        })
        .catch((e) => {
          alert(e); 
          console.error(e)
        });
    }
  }

  stopThecamera() {
    if (this.video) {
      try {
        (this.video.nativeElement.srcObject as MediaStream).getVideoTracks()[0].stop();
      } catch (error) {
        console.debug("Camera permission not granted");
      }

      this.cameraOn = false;
      this.barcodeFound = false;
    }   
  }

  private initializeCanvas(): CanvasRenderingContext2D {
    if(this.canvas === undefined || this.video === undefined) {
      return;
    }

    const context = this.canvas.nativeElement;
    context.width = this.width;
    context.height = this.height;
    return context.getContext("2d", { willReadFrequently: true });
  }

  private renderCanvas(): void {
    this.imageContext.clearRect(0, 0, this.width, this.height);
    this.animationId = requestAnimationFrame(() => this.renderCanvas());

    this.imageContext.drawImage(
      this.video.nativeElement,
      (this.video.nativeElement.videoWidth - this.width) / 2,
      (this.video.nativeElement.videoHeight - this.height) / 2,
      this.width, 
      this.height,
      0,
      0,
      this.width,
      this.height
    );

    var base64String = this.canvas.nativeElement.toDataURL();
    if(this.barcodeFound === false) {
      try {
        const result = process_image(base64String.split(',')[1])
        if(result !== "NOBARCODE" && result !== '' && result !== this.lastRenderingResult) {
            this.lastRenderingResult = result;
            this.triggerScan(result); // Important: This is dispatching a keyboard event in the called function, the bar code scanner component is listening to keypress events which will intercept that event from here!!! (It's confusing I know)
        }
      } catch (e) {
        //ignore errors
      }
    }
  }

  private triggerScan(items){
    for(var i = 0; i < items.length; i++){
      const item = items[i];
      const event = new KeyboardEvent('keypress', {key: item});
      window.dispatchEvent(event);
    }

    const event = new KeyboardEvent('keypress', {key: 'Enter'});
    window.dispatchEvent(event);
  }
}